import {
  ApiReturnCampaign,
  FixedTimeRangeConfig,
} from '@highimpact-frontend/api-types';
import { Box } from '@mui/material';
import { useState } from 'react';
import DropDownMultiAutocompleteComponent from './dropDownAutocompleteMultiSelector';
import {
  buildFixedTimeRanges,
  getDefaultCampaignsFromFixedConfigs,
} from './FixedTimeRange';

type FixedTimeRangeProps = {
  onChange: (range: FixedTimeRangeConfig[]) => void;
  campaigns: ApiReturnCampaign[];
  noDivision: boolean;
  defaultIntervals?: FixedTimeRangeConfig[];
};

function FixedTimeRangeForm({
  onChange,
  campaigns,
  noDivision = false,
  defaultIntervals,
}: FixedTimeRangeProps) {
  const [selected, setSelected] = useState<ApiReturnCampaign[]>(() =>
    getDefaultCampaignsFromFixedConfigs(defaultIntervals, campaigns)
  );

  return (
    <Box className="nav-form-group with-space">
      <DropDownMultiAutocompleteComponent
        label="Campagnes"
        options={campaigns}
        value={selected}
        onChange={(value) => {
          const nextRange = buildFixedTimeRanges(value, noDivision);
          setSelected(value);
          onChange(nextRange);
        }}
      />
    </Box>
  );
}

export default FixedTimeRangeForm;
